import * as React from "react";
import * as ReactDOM from 'react-dom';
import WordLidForm from "../forms/WordLidForm";
import WidgetForm from "../forms/WidgetForm";

function initReact(formDefinitions: FormDefinition, formId: string, reactId: string = null) {  

  ReactDOM.render(
    <React.StrictMode>
      {(() => {
          switch (formId) {
          case "word-lid-form":
            return <WordLidForm formDefinitions={formDefinitions} />
          case "widget":
            return <WidgetForm reactId={reactId} />
          default:
            break;
        }
      })()}
    </React.StrictMode>,
    reactId ? document.getElementById(`root-${reactId}`) : document.getElementById('root')
  );
}

export { initReact };